"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const toolbox_browser_fetch_1 = require("@zapier/toolbox-browser-fetch");
const toolbox_redux_framework_1 = require("@zapier/toolbox-redux-framework");
const url_utils_1 = require("@zapier/url-utils");
const lodash_1 = require("lodash");
const constants_1 = require("./constants");
const normalizeZaps_1 = __importDefault(require("./normalizeZaps"));
function getZaps(accountId, path, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const zaps = yield toolbox_browser_fetch_1.getJsonWithAccountId(accountId, url_utils_1.addParamsToUrl(`/api/v3/${path}`, params));
            return normalizeZaps_1.default(zaps);
        }
        catch (response) {
            throw new toolbox_redux_framework_1.commonErrors.DataGetError({
                resource: toolbox_redux_framework_1.resourceNames.zaps,
                response,
            });
        }
    });
}
function getUntrashedZaps(accountId) {
    return __awaiter(this, void 0, void 0, function* () {
        return getZaps(accountId, 'zaps');
    });
}
function getTrashedZaps(accountId) {
    return __awaiter(this, void 0, void 0, function* () {
        const zaps = yield getZaps(accountId, 'zaps/trash', {
            trash_days: constants_1.TRASH_DAYS,
        });
        return lodash_1.mapValues(zaps, (zap) => (Object.assign(Object.assign({}, zap), { folder_ids: [constants_1.TRASH_FOLDER_ID] })));
    });
}
function fetchZaps(accountId) {
    return __awaiter(this, void 0, void 0, function* () {
        const untrashed = yield getUntrashedZaps(accountId);
        const trashed = yield getTrashedZaps(accountId);
        return Object.assign(Object.assign({}, untrashed), trashed);
    });
}
exports.default = fetchZaps;
